import axios from 'axios'
import _get from 'lodash/get'

export const CAPITAL_GAINS_GET = 'CAPITAL_GAINS_GET'
export const CAPITAL_GAINS_UPDATE = 'CAPITAL_GAINS_UPDATE'
export const CAPITAL_GAINS_SAVE = 'CAPITAL_GAINS_SAVE'
export const CAPITAL_GAINS_SAVING = 'CAPITAL_GAINS_SAVING'
export const CAPITAL_GAINS_SAVE_SUCCESS = 'CAPITAL_GAINS_SAVE_SUCCESS'
export const CAPITAL_GAINS_SAVE_ERROR = 'CAPITAL_GAINS_SAVE_ERROR'

export const getCapitalGains = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/capitalgains/${selfAssessmentId}`)
        .then((response) => {
            const capitalGains = { ...response.data, shouldFetch: false, fetchSuccessful: true }

            dispatch(updateCapitalGains(capitalGains))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updateCapitalGains({ shouldFetch: false, fetchSuccessful: true }))
            }
        })
}

export const updateCapitalGains = (capitalGains) => ({
    type: CAPITAL_GAINS_UPDATE,
    capitalGains,
})

export const saveCapitalGains = () => (dispatch, getState) => {
    const { assessment, capitalGains } = getState()

    dispatch(capitalGainsSaving, capitalGains)

    axios
        .put(`/capitalgains/${assessment.id}`, { ...capitalGains, selfAssessmentId: assessment.id })
        .then((response) => {
            const data = {
                ...response.data,
                isAllowanceUpdate: capitalGains.isAllowanceUpdate,
                shouldGoToNextAllowanceQuestion: capitalGains.shouldGoToNextAllowanceQuestion,
            }

            dispatch(capitalGainsSaveSuccess(data))
        })
        .catch((error) => {
            dispatch(capitalGainsSaveError(capitalGains, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveCapitalGains = (capitalGains) => (dispatch) => {
    dispatch(updateCapitalGains(capitalGains))
    dispatch(saveCapitalGains())
}

export const capitalGainsSaving = (capitalGains) => ({
    type: CAPITAL_GAINS_SAVING,
    capitalGains,
})

export const capitalGainsSaveSuccess = (capitalGains) => ({
    type: CAPITAL_GAINS_SAVE_SUCCESS,
    capitalGains,
})

export const capitalGainsSaveError = (capitalGains, error) => ({
    type: CAPITAL_GAINS_SAVE_ERROR,
    capitalGains,
    error,
})
